export default __webpack_public_path__ + "static/media/crypto-currency.7809ec2e.svg";